import {ProblemDetails} from '../types';

export default function isProblemDetails(obj: unknown): obj is ProblemDetails {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }

    const problem = obj as ProblemDetails;

    if (
        !('type' in obj || 'title' in obj || 'status' in obj || 'detail' in obj)
    ) {
        return false;
    }

    const stringOrNullish = (value: unknown) =>
        typeof value === 'string' || value === null || value === undefined;

    return (
        stringOrNullish(problem.type) &&
        stringOrNullish(problem.title) &&
        (typeof problem.status === 'number' ||
            problem.status === null ||
            problem.status === undefined) &&
        stringOrNullish(problem.detail) &&
        stringOrNullish(problem.instance)
    );
}
